/**
 * Suggestion row for BinomTagsField — clickable existing-tag chips drawn from
 * /binom/tags. Selecting one calls onPick(name).
 *
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';

import type { BinomTag } from '@/hooks/binom';

export interface BinomTagChipListProps {
  suggestions: BinomTag[];
  onPick: (name: string) => void;
}

const BinomTagChipList: FC<BinomTagChipListProps> = ({ suggestions, onPick }) => {
  if (suggestions.length === 0) return null;
  return (
    <div className="flex flex-wrap gap-1">
      {suggestions.map((t) => (
        <button
          key={t.id}
          type="button"
          onClick={() => onPick(t.name)}
          className="rounded border border-border/60 bg-muted/40 px-1.5 py-0.5 text-[10px] text-muted-foreground hover:bg-muted hover:text-foreground"
        >
          {t.name}
        </button>
      ))}
    </div>
  );
};

export default BinomTagChipList;
